"use client"

import { useState } from "react"
import { FeedData as Feed } from "@extractus/feed-extractor"
import { processSourceData } from "../../../utils/importHelpers"

/**
 * Hook for handling file processing and post extraction
 */
export default function useRSSFile(
  feed: Feed | null,
  url: string | null,
  exportFile: File | null
) {
  const [isFileLoading, setIsFileLoading] = useState(false)
  const [posts, setPosts] = useState<any[] | null>(null)
  const [fileError, setFileError] = useState<string | null>(null)

  /**
   * Handles initial file/feed processing to create importable posts
   */
  const handleCreateNotes = async () => {
    if (!feed && !exportFile) return

    setIsFileLoading(true)
    setFileError(null)

    try {
      const processedNotes = await processSourceData(exportFile, feed, url)
      setPosts(processedNotes)
    } catch (e) {
      console.error("Error processing import:", e)
      // Provide more specific error messaging
      let errorMessage
      if (typeof e === "string") {
        errorMessage = e
      } else if (e instanceof Error) {
        errorMessage = e.message
      } else {
        errorMessage =
          "Failed to process import. Please ensure you've uploaded a valid export file."
      }
      setFileError(errorMessage)
    } finally {
      setIsFileLoading(false)
    }
  }

  return {
    isFileLoading,
    posts,
    fileError,
    handleCreateNotes,
  }
}
